import request from '../../axios';

interface IProps {
  pageParam: number;
  payload?: {brandId: number; pageSize?: number};
}

export const getMyStoreSubBrands = async ({pageParam, payload}: IProps) => {
  const {data}: {data: IMyStoreSubBrandsResponse} = await request.get(
    `/api/v2/warehouse/my-store-sub-brand/${payload?.brandId}`,
    {
      params: {
        page: pageParam,
        page_size: payload?.pageSize ?? 10,
      },
    },
  );

  return data;
};
